<template>
  <v-app>
    <transition name="splash-fade">
      <SplashOverlay v-if="showSplash" @done="showSplash = false" />
    </transition>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import SplashOverlay from '@/components/SplashOverlay.vue'

export default {
  name: 'App',
  components: { SplashOverlay },
  data() {
    return {
      showSplash: true
    }
  }
}
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
body { background: #030b0e; }

.splash-fade-leave-active {
  transition: opacity 0.8s ease;
}
.splash-fade-leave-to {
  opacity: 0;
}
</style>
